export function formatViews(n: number): string {
  if (!Number.isFinite(n) || n < 0) return '0'
  const v = Math.floor(n)
  if (v < 1000) return String(v)
  if (v < 1_000_000) {
    const k = v / 1000
    return `${k >= 100 ? Math.round(k) : k.toFixed(1).replace(/\.0$/, '')}K`
  }
  if (v < 1_000_000_000) {
    const m = v / 1_000_000
    return `${m >= 100 ? Math.round(m) : m.toFixed(1).replace(/\.0$/, '')}M`
  }
  return `${(v / 1_000_000_000).toFixed(1).replace(/\.0$/, '')}B`
}

export function formatViewsExact(n: number): string {
  if (!Number.isFinite(n) || n < 0) return '0'
  return Math.floor(n).toLocaleString('en-US')
}
